import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from './DataTableColumnHeader';
import { getMappedTransactionType } from '../utils';

export type Fulfillment = {
  id: string;
  event_account: string;
  item_location: string;
  type: string;
  item_count: number;
  timestamp: string;
};

export const columns: ColumnDef<Fulfillment>[] = [
  // {
  //   id: 'select',
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && 'indeterminate')
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label="Select all"
  //       className="tw:translate-y-[0px]! tw:flex tw:size-4 tw:items-center tw:justify-center tw:rounded-[4px] tw:border tw:border-input"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label="Select row"
  //       className="tw:translate-y-[0px]! tw:flex tw:size-4 tw:items-center tw:justify-center tw:rounded-[4px] tw:border tw:border-input"
  //     />
  //   ),
  // },
  {
    accessorKey: 'event_account',
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={i18n.t('OrderFulfillment:eventAccount')}
      />
    ),
    cell: ({ row }) => (
      <div className="tw:min-w-[200px]">{row.getValue('event_account')}</div>
    ),
    meta: {
      getName: () => i18n.t('OrderFulfillment:eventAccount'),
    },
    enableSorting: false,
    filterFn: 'arrIncludesSome',
  },
  {
    accessorKey: 'item_location',
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={i18n.t('OrderFulfillment:itemLocation')}
      />
    ),
    cell: ({ row }) => (
      <div className="tw:w-[220px]">{row.getValue('item_location')}</div>
    ),
    meta: {
      getName: () => i18n.t('OrderFulfillment:itemLocation'),
    },
    enableSorting: false,
    filterFn: 'arrIncludesSome',
  },
  {
    accessorKey: 'type',
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={i18n.t('OrderFulfillment:type')}
      />
    ),
    cell: ({ row }) => (
      <div className="tw:w-[80px]">
        {getMappedTransactionType(row.getValue('type'))}
      </div>
    ),
    meta: {
      getName: () => i18n.t('OrderFulfillment:type'),
    },
    enableSorting: false,
    filterFn: 'arrIncludesSome',
  },
  {
    accessorKey: 'item_count',
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={i18n.t('OrderFulfillment:itemCount')}
      />
    ),
    cell: ({ row }) => (
      <div className="tw:w-[80px] tw:text-center">
        {row.getValue('item_count')}
      </div>
    ),
    meta: {
      getName: () => i18n.t('OrderFulfillment:itemCount'),
    },
  },
  {
    accessorKey: 'timestamp',
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={i18n.t('OrderFulfillment:timestamp')}
      />
    ),
    cell: ({ row }) => {
      const dateString = new Date(row.getValue('timestamp')).toLocaleDateString(
        i18n.language,
        getDateFormatOptions(true),
      );
      return <div className="tw:min-w-[240px]">{dateString}</div>;
    },
    meta: {
      getName: () => i18n.t('OrderFulfillment:timestamp'),
    },
  },
];
